var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-progress-linear',{attrs:{"dark":"","indeterminate":"","color":"secondary","height":"20","striped":""}},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }